import gettext from '@sdk/lang/gettext';
import validateNumber, {
  ValidateOptions,
  ValidNumberOption,
} from '@sdk/utils/validation/validateNumber';

export const getShiftBreakDefaultDuration = (value: number | string): number | string =>
  String(value) === '0' ? gettext('No break') : value;

export const validateShiftBreakDefaultDuration = (value: string | number): boolean =>
  validateNumber(value, {
    [ValidateOptions.validNumber]: ValidNumberOption.nonNegative,
    [ValidateOptions.integer]: true,
  });
